import { defineMessages } from 'react-intl';

const messages = defineMessages({
  seoTitle: 'Error - LodgeLink',
  defaultErrorMessage: 'A {type} error has occurred on the server.',
  retryButton: 'RETRY'
});

export default messages;
